import _taggedTemplateLiteral from "/root/code/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { hoverColorProp, styled } from "@catchoftheday/theme";
import { Button } from "./Button";
export var LinkButton = styled(Button.withComponent("a", process.env.NODE_ENV === "production" ? {
  target: "eouzdxi0"
} : {
  target: "eouzdxi0",
  label: "LinkButton"
}))(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  &:hover,\n  &:focus {\n    text-decoration: none;\n    ", "\n  }\n  &[disabled] {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }\n"])), hoverColorProp);
LinkButton.displayName = "LinkButton";
LinkButton.defaultProps = {
  variant: "primary",
  sizeVariant: "md",
  block: true,
  textTransform: "uppercase",
  hoverColor: "white",
  whiteSpace: "nowrap"
};
export default LinkButton;